import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { trackButtonClick } from "@/utils/analyticsTracker";

interface UpdateItem {
  id: string | number;
  title: string;
  link: string;
}

const ScrollingUpdates = () => {
  const [updates, setUpdates] = useState<UpdateItem[]>([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const dummyUpdates: UpdateItem[] = [
    {
      id: "update-1",
      title: "Introducing Interactive coding playground for ML theory questions",
      link: "/learn",
    },
  ];

  useEffect(() => {
    // Since there's no "updates" table in the database, use dummy data
    setUpdates(dummyUpdates);
  }, []);

  useEffect(() => {
    if (updates.length === 0) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % updates.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [updates]);

  const handleUpdateClick = (update: UpdateItem) => {
    trackButtonClick(`scrolling_update_${update.id}`, {
      extraData: {
        updateTitle: update.title,
        updateLink: update.link,
        updateId: update.id
      }
    });
  };

  return (
    <div className="w-full bg-background border-b overflow-hidden">
      <div
        className="flex items-center transition-transform duration-500"
        style={{ transform: `translateX(-${activeIndex * 100}%)` }}
      >
        {updates.map((update) => (
          <div
            key={update.id}
            className="h-8 flex items-center justify-center min-w-full px-4"
          >
            <span className="text-base md:text-lg font-semibold">
              <Link 
                to={update.link} 
                className="text-primary underline"
                onClick={() => handleUpdateClick(update)}
              >
                {update.title}
              </Link>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScrollingUpdates;
